export default __webpack_public_path__ + "static/media/screen5.5ce324b9.jpg";